import { ICustomField } from "@webapp/custom-fields/models/custom-fields.models";

export const filterCustomFieldsBySession = (sessionId: string, cfs: ICustomField[]): ICustomField[] => {
  return cfs.filter((value) => {
    return !value.operationalType || value.operationalType == "global" || (value.targetIds && value.targetIds.includes(sessionId));
  });
};
